const initialState = {
  uid: null,
  name: '',
  phoneNumber: '',
  isAuthenticated: false,
};

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_USER':
      return {
        ...state,
        uid: action.payload.uid,
        name: action.payload.name,
        phoneNumber: action.payload.phoneNumber,
        isAuthenticated: action.payload.isAuthenticated,
      };
    default:
      return state;
  }
};

export default userReducer;